module.exports = __webpack_public_path__ + "static/360_icon-fc4f1a4b9d5d0ee97023031b4e9700d6.png";